import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

export abstract class ValidationProfiler {
  public abstract getExecDurationSubj(): Subject<number> | null;
}

@Injectable()
export class ValidationProfilingAnalyzer {
  private _results: number[] = [];
  max(): number {
    return Math.max(...this._results);
  }
  average(): number {
    return this._results.reduce((p, c) => (p += c)) / this._results.length;
  }
  resultsCount(): number {
    return this._results.length;
  }
  handleNewResult(result: number) {
    this._results.push(result);
  }
  report(): string {
    return 'validation: count: ' + this.resultsCount() + '; max result: ' + this.max() + ' ms; average result: ' + this.average() + ' ms.';
  }
  clear() {
    this._results = [];
  }
}
